module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":{"locale":"Region & Language"}},"ja":{"message":{"locale":"言語・地域を選択"}}}')
  delete Component.options._Ctor
}
